import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

import { Icon, Button } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    width: 200,
    padding: theme.spacing(1.25, 3.25, 1.25, 2.5),
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
}));

interface PrimaryCtaProps {
  className: string | undefined,
  [others: string]: any,
  children?: React.ReactNode
}

export default function PrimaryCTA ({
  className: classNameProp,
  children,
  ...others
}: PrimaryCtaProps) {
  const classes = useStyles();
  const className = classnames(classes.root, classNameProp);
  return (
    <Button
      variant='contained'
      color='primary'
      size='large'
      startIcon={<Icon type='plus' color='white' />}
      className={className}
      {...others}
    >
      {children}
    </Button>
  );
}
